export const PinchCloseIcon = () => <svg width="32" height="32" viewBox="0 0 895.9 895.9" data-sentry-element="svg" data-sentry-component="PinchCloseIcon" data-sentry-source-file="pinch-close.tsx">
    <rect x="-12.3" y="-9.5" style={{
    fill: '#112030'
  }} width="918.9" height="913.3" data-sentry-element="rect" data-sentry-source-file="pinch-close.tsx" />
    <polygon style={{
    fill: '#FFFFFF'
  }} points="708.3,258.3 637.6,187.6 448,377.2 258.3,187.6 187.6,258.3 377.2,447.9 187.6,637.6 258.3,708.3
	448,518.7 637.6,708.3 708.3,637.6 518.7,447.9 " data-sentry-element="polygon" data-sentry-source-file="pinch-close.tsx" />
  </svg>;